var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 2.66666C8.63935 2.66666 2.66602 8.63999 2.66602 16C2.66602 23.36 8.63935 29.3333 15.9993 29.3333C23.3594 29.3333 29.3327 23.36 29.3327 16C29.3327 8.63999 23.3594 2.66666 15.9993 2.66666ZM21.3727 13.6L15.146 19.8133C14.9593 20.0133 14.706 20.1067 14.4393 20.1067C14.186 20.1067 13.9327 20.0133 13.7327 19.8133L10.626 16.7067C10.2394 16.32 10.2394 15.68 10.626 15.2933C11.0127 14.9066 11.6527 14.9066 12.0393 15.2933L14.4393 17.6933L19.9594 12.1867C20.346 11.7867 20.986 11.7867 21.3727 12.1867C21.7593 12.5733 21.7593 13.2 21.3727 13.6Z",
    fill: "#03D98C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cbff8d8b46e1bc04f856d040774cc850.svg";
export { ForwardRef as ReactComponent };